import { render, staticRenderFns } from "./AppUpgrade.vue?vue&type=template&id=7be416d3&scoped=true"
import script from "./AppUpgrade.vue?vue&type=script&lang=js"
export * from "./AppUpgrade.vue?vue&type=script&lang=js"
import style0 from "./AppUpgrade.vue?vue&type=style&index=0&id=7be416d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be416d3",
  null
  
)

export default component.exports